import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import xauCss from '@src/components/xfe-animation-css';
import Button from '@src/components/button';
import Store from './store';
import BackTopFooter from '@src/business-components/backtop-footer';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import formatLocaleDate from '@src/utils/format-locale-date';
import redirect from '@src/utils/redirect-if-mobile-accress';
// PC端页面，如果是移动端访问，跳转到移动端页面
redirect.redirectIfMobile();
const styles = require('./index.less');

const NewsDetail = ({ store }) => {
  store.use();

  return (
    <Page className={cx(styles.root, store.isActive && xauCss.AOS_ROOT, 'page-main')}>
      <div className={styles.container}>
        <div className={cx(styles.btnBack, { ...xauCss.AOS_FADE.IN_RIGHT.FAST_DELAY(1) })}>
          <Button
            style={{ backgroundImage: `url(${require('./images/' + getLanguageByPath() + '/btn-back.png')})` }}
            className={styles.btnBackInner}
            onClick={store.back}
          />
        </div>
        <div id="content" className={styles.inner}>
          <h2 className={cx(styles.title, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(1) })}>{store.article_title}</h2>
          <div className={cx(styles.divider, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(2) })} />
          <div className={cx(styles.date, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })}>
            {/* <span className={styles.tag}>{store.categoryName}</span> */}
            {formatLocaleDate(store.date)}
          </div>
          <div className={cx(styles.content, { ...xauCss.AOS_FADE.IN_UP.FAST_DELAY(3) })} dangerouslySetInnerHTML={{ __html: store?.content }} />
        </div>
      </div>
      <BackTopFooter />
    </Page>
  );
};

export default wrapStore(NewsDetail, Store);
